<div class="main-content">
    <div class="container-fluid ">
        <div class="card ">
            <div class="card-header card-header-primary p-1">
                <div class="row">
                    <div class="col-sm-10 col-md-11">
                        <h4 class="card-title mt-2 font-weight-bold">Detalle solicitud perfil</h4>
                    </div>
                    <div class="col-sm-2 col-md-1">
                        <button mat-icon-button (click)="onCloseClick()" tabindex="0">
                            <mat-icon>clear</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body  p-3 pt-2">

                <div class="card mt-1 mb-0">
                    <div class="row">
                        <div class="col-5 mt-auto mb-auto">
                            <div class="row ">
                                <div class="col mt-1">
                                    <p class="pl-1">Estatus: <span class="badge rounded-pill"
                                            [ngClass]="ticketBase.nombreEstaus.toLowerCase()">{{ticketBase.nombreEstaus}}</span>
                                    </p>
                                </div>
                                <div class="col mt-1">
                                    <p class="pl-1">Prioridad: <span
                                            class="badge rounded-pill bg-info">{{ticketBase.prioridad}}</span> </p>
                                </div>

                            </div>
                        </div>
                        <div class="col text-right">
                            <div class="btn-group m-0" role="group" aria-label="bar-btns-detalle-perfil">
                                <button mat-raised-button class="btn btn-warning" *ngIf="ticketBase.id_estatus== ESTATUS.ABIERTA && esResolutor" (click)="onClickProcesar()">
                                    <i class="material-icons">settings</i>Proceso </button>
                                <button mat-raised-button class="btn btn-warning" *ngIf="ticketBase.id_estatus== ESTATUS.PROCESO && esReclutamiento" (click)="onClickReclutar()">
                                    <i class="material-icons">supervisor_account</i>Reclutamiento </button>
                                <button mat-raised-button class="btn btn-warning" *ngIf="ticketBase.id_estatus==ESTATUS.PROCESO && esResolutor" (click)="onClickAtender()">
                                    <i class="material-icons">done_outline</i>Atendido</button>
                                <button mat-raised-button class="btn btn-success" *ngIf="ticketBase.id_estatus!=ESTATUS.VOBO && ticketBase.id_estatus!=ESTATUS.CANCELADA" (click)="onClickComentar()">
                                    <i class="material-icons">add_comment</i>Comentar</button>
                                <button mat-raised-button class="btn btn-primary" *ngIf="ticketBase.id_estatus!=ESTATUS.VOBO && ticketBase.id_estatus!=ESTATUS.CANCELADA"
                                    (click)="onClickCancelar()">
                                    <i class="material-icons">clear</i>Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mt-2 mb-0">
                    <div class="row">
                        <div class="col">
                            <table id="tbl-gral-datos" class="table table-borderless m-0 tabla-info-solicitud"
                                aria-describedby="Tbl gral de detalle">
                                <tbody>
                                    <tr>
                                        <th class="td-titulo-dato">Solicitante:</th>
                                        <th class="td-titulo-dato">Área solicitante:</th>
                                        <th class="td-titulo-dato">Área resolutora:</th>
                                        <th class="td-titulo-dato">Fecha de solicitud:</th>

                                    </tr>
                                    <tr>
                                        <td class="td-valor-dato">{{ticketBase.nombreSolicitante}}</td>
                                        <td class="td-valor-dato">{{ticketBase.areaSolicitante}}</td>
                                        <td class="td-valor-dato">{{ticketBase.areaResolutora}}</td>
                                        <td class="td-valor-dato">{{ticketBase.fechaSolicitud | date:'dd/MM/yyyy
                                            HH:mm'}}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row" id="container-datos-perfil">
                    <div class="col-md-5 col-sm-12 ">
                        <div class="card mt-2 mb-0">
                            <div class="card-header card-titulo">
                                <p class="card-title font-weight-bold">Detalle de solicitud</p>
                            </div>
                            <div class="card-body p-0">
                                <mat-tab-group dynamicHeight>
                                    <mat-tab label="Perfil">
                                        <div class="example-medium-box mat-elevation-z4">
                                            <table id="tbl-perfil-datos" class="table mt-2 tabla-info-solicitud"
                                                aria-describedby="Tbl detalle de perfi">
                                                <tbody>
                                                    <tr>
                                                        <th class="td-titulo-dato">Perfil solicitado:</th>
                                                        <th class="td-valor-dato">{{ticketPerfil.perfil}}</th>

                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Cantidad de perfiles:</td>
                                                        <td class="td-valor-dato">{{ticketPerfil.numPerfiles}}
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Nivel de perfil:</td>
                                                        <td class="td-valor-dato">{{ticketPerfil.nivelPerfil}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Años de experiencia:</td>
                                                        <td class="td-valor-dato">{{ticketPerfil.experiencia}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Ingles:</td>
                                                        <td class="td-valor-dato">{{ticketPerfil.ingles}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Conocimientos:</td>
                                                        <td class="td-valor-dato">
                                                           {{ticketPerfil.conocimientoDeseable}} 
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </mat-tab>
                                    <mat-tab label="Cliente">
                                        <div class="example-medium-box mat-elevation-z4 card-description">
                                            <table id="tbl-cliente-datos" class="table mt-2 tabla-info-solicitud"
                                                aria-describedby="Tbl detalle de cliente">
                                                <tbody>
                                                    <tr>
                                                        <th class="td-titulo-dato">Cliente:</th>
                                                        <th class="td-valor-dato">{{ticketPerfil.nombreCliente}}
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Ubicación:</td>
                                                        <td class="td-valor-dato">
                                                            {{ticketPerfil.ubicacionCliente}}</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </mat-tab>
                                    <mat-tab label="Proyecto">
                                        <div class="example-medium-box mat-elevation-z4">
                                            <table id="tbl-proyecto-datos" class="table mt-2 tabla-info-solicitud"
                                                aria-describedby="Tbl detalle de proyecto">
                                                <tbody>
                                                    <tr>
                                                        <th class="td-titulo-dato">Proyecto:</th>
                                                        <th class="td-valor-dato">{{ticketPerfil.tipoProyecto}}
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Fecha inicio:</td>
                                                        <td class="td-valor-dato">{{ticketPerfil.fechaInicio |
                                                            date:'dd/MM/yyyy'}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Fecha fin:</td>
                                                        <td class="td-valor-dato">{{ticketPerfil.fechaFin |
                                                            date:'dd/MM/yyyy'}}</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </mat-tab>
                                    <mat-tab label="Salario">
                                        <div class="example-medium-box mat-elevation-z4">
                                            <table id="tbl-salario-datos" class="table mt-2 tabla-info-solicitud"
                                                aria-describedby="Tbl detalle de proyecto">
                                                <tbody>
                                                    <tr>
                                                        <th class="td-titulo-dato">Tipo de contratación:</th>
                                                        <th class="td-valor-dato">
                                                            {{ticketPerfil.tipoContratacion}}</th>

                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Horario:</td>
                                                        <td class="td-valor-dato">{{ticketPerfil.horario}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Tarifa:</td>
                                                        <td class="td-valor-dato">{{ticketPerfil.tarifa | currency:"MXN":"symbol"}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Sueldo:</td>
                                                        <td class="td-valor-dato">{{ticketPerfil.sueldoOferta | currency:"MXN":"symbol"}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="td-titulo-dato">Esquema de sueldo:</td>
                                                        <td class="td-valor-dato">{{ticketPerfil.esquemaSueldo}}
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </mat-tab>
                                </mat-tab-group>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-7 col-sm-12 ">
                        <div class="card mt-2">
                            <div class="card-header card-titulo">
                                <p class="card-title font-weight-bold">Comentarios</p>
                            </div>
                            <div class="card-body p-0">

                                <mat-accordion class="example-headers-align" multi>
                                    <mat-expansion-panel *ngFor="let comentario of listComentario">
                                        <mat-expansion-panel-header class="font-weight-normal">
                                            <mat-panel-title>

                                                <mat-icon>date_range</mat-icon>
                                                {{comentario.fecha | date:'dd/MM/yy HH:mm' }}
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                <mat-icon>account_circle</mat-icon>
                                                {{comentario.nombreUsuario}}
                                                <span class="badge rounded-pill  ml-3"
                                                    [ngClass]="comentario.nombreEstatus.toLowerCase()">{{comentario.nombreEstatus}}</span>
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>


                                        <div class="text-muted">
                                            {{comentario.descripcion}}
                                        </div>
                                        <ul class="list-inline">
                                            <li class="list-inline-item" *ngFor="let archivo of comentario.evidencias">
                                                <a class="icon-file-solicitud"> {{archivo.nombre}}</a>
                                                <button mat-icon-button aria-label="Descargar archivo"
                                                    (click)="descargarArchivo(archivo)">
                                                    <mat-icon>download</mat-icon>
                                                </button>
                                            </li>
                                        </ul>

                                    </mat-expansion-panel>
                                </mat-accordion>
                                <a #linkDescargaArchivos aria-label="Descargar archivo"></a>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

    </div>
</div>